import styled from "styled-components"

import ButtonBase from "@irati/ui/src/Button"
import {Card as CardBase} from "@irati/ui/src/Layout"
import padding from "@irati/ui/src/global/padding"
import {BRAND_LOGO_DIMENSIONS} from "@irati/brand/constants/brand"

export const Button = styled(ButtonBase)`
  margin: 0 auto;
  display: block;
`

export const MainSection = styled.div`
  height: 100%;
  background-color: white;
  padding: ${padding.base}
`

export const MainSectionImage = styled.img`
  display: block;
  margin-bottom: ${padding.small};
  max-width: ${BRAND_LOGO_DIMENSIONS.width}px;
  max-height: ${BRAND_LOGO_DIMENSIONS.height}px;
`

export const PerksImage = styled.img`
  width: 300px;
  height: 200px;
  display: block;
  margin: ${padding.base} auto;
`

export const Card = styled(CardBase)`
  width: 360px;
`
